import { apiClient } from '@/lib/api-client';

export interface DfsLocation {
  code: number;
  name: string;
  parent: number | null;
  iso: string;
  type: 'Country' | 'Region' | 'State';
}

export interface DfsLanguage {
  name: string;
  code: string;
}

export async function searchDfsCountries(q: string): Promise<DfsLocation[]> {
  const { data } = await apiClient.get<{ items: DfsLocation[] }>('/v1/dataforseo/locations', {
    params: { q, type: 'Country', limit: 100 },
  });
  return data.items;
}

export async function searchDfsRegions(country: string, q: string): Promise<DfsLocation[]> {
  if (!country) return [];
  const { data } = await apiClient.get<{ items: DfsLocation[] }>('/v1/dataforseo/locations', {
    params: { q, country, limit: 200 },
  });
  return data.items.filter((location) => location.type !== 'Country');
}

export async function fetchDfsLanguagesForCountry(country: string): Promise<DfsLanguage[]> {
  const { data } = await apiClient.get<{ items: DfsLanguage[] }>('/v1/dataforseo/languages', {
    params: country ? { country } : {},
  });
  return data.items;
}
